/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Collaboration (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define('collaboration/glass/utils/GlassUtil',[], function () {
	// perspective menu items that are defined in perspectives/common/collaboration.json
	var perspective = Object.freeze({
		current: Object.freeze({
			SEND: 'com.ibm.ca.collaboration.sendCurrent',
			LINK: 'com.ibm.bi.glass.common.operations.shareCurrent',
			EMBED: 'com.ibm.bi.glass.common.operations.embedCurrent',
			EXPORT: 'com.ibm.bi.dashboard.exportPdf',
			EMAIL: 'com.ibm.ca.collaboration.emailCurrent',
			EMAIL_LINK: 'com.ibm.ca.collaboration.emailLinkCurrent',
			EMAIL_IMAGE: 'com.ibm.ca.collaboration.emailImageCurrent',
			EMAIL_REPORT_CURRENT: 'com.ibm.ca.collaboration.emailReportCurrent'
		}),
		contextual: Object.freeze({
			SEND: 'com.ibm.ca.collaboration.sendContextual',
			LINK: 'com.ibm.bi.glass.common.shareContextual',
			EMBED: 'com.ibm.bi.glass.common.embedContextual',
			EMAIL: 'com.ibm.ca.collaboration.emailContextual',
			EMAIL_LINK: 'com.ibm.ca.collaboration.emailLinkContextual',
			EMAIL_IMAGE: 'com.ibm.ca.collaboration.emailImageContextual',
			EMAIL_REPORT_CONTEXTUAL: 'com.ibm.ca.collaboration.emailReportContextual'
		})
	});

	var feature = Object.freeze({
		SEND: 'send',
		LINK: 'link',
		EMBED: 'embed',
		EXPORT: 'export',
		EMAIL: 'email',
		EMAIL_LINK: 'emailLink',
		EMAIL_IMAGE: 'emailImage',
		EMAIL_REPORT_CURRENT: 'emailReportCurrent',
		EMAIL_REPORT_CONTEXTUAL: 'emailReportContextual'
	});

	function _currentMap() {
		var map = {};
		map[perspective.current.SEND] = feature.SEND;
		map[perspective.current.LINK] = feature.LINK;
		map[perspective.current.EMBED] = feature.EMBED;
		map[perspective.current.EXPORT] = feature.EXPORT;
		map[perspective.current.EMAIL] = feature.EMAIL;
		map[perspective.current.EMAIL_LINK] = feature.EMAIL_LINK;
		map[perspective.current.EMAIL_IMAGE] = feature.EMAIL_IMAGE;
		map[perspective.current.EMAIL_REPORT_CURRENT] = feature.EMAIL_REPORT_CURRENT;
		return Object.freeze(map);
	}

	function _contextualMap() {
		var map = {};
		map[perspective.contextual.SEND] = feature.SEND;
		map[perspective.contextual.LINK] = feature.LINK;
		map[perspective.contextual.EMBED] = feature.EMBED;
		map[perspective.contextual.EMAIL] = feature.EMAIL;
		map[perspective.contextual.EMAIL_LINK] = feature.EMAIL_LINK;
		map[perspective.contextual.EMAIL_IMAGE] = feature.EMAIL_IMAGE;
		map[perspective.contextual.EMAIL_REPORT_CONTEXTUAL] = feature.EMAIL_REPORT_CONTEXTUAL;
		return Object.freeze(map);
	}

	var map = Object.freeze({
		current: _currentMap(),
		contextual: _contextualMap()
	});

	return { perspective: perspective, feature: feature, map: map };
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

